import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "imageHolder" }
const _hoisted_2 = { class: "contentHolder" }

import { IonCard, IonCardTitle, IonCardSubtitle } from '@ionic/vue';
//Composables
import useUser from "@/composables/useUser";
//Components
import AImage from "@/components/Base/AImage.vue";
//Helpers
import { getPhotoUrl } from "@/utilities/get-media-url";


//Props

export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectCard',
  props: {
  project: {
    type: Object,
    required: true
  }
},
  setup(__props) {

const props = __props;



const { user } = useUser();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonCard), { class: "rounded-sm bg-white acon-card-shadow p-4 projectCardHolder" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(AImage, {
          "image-class": `w-28 h-28 md:h-32 object-cover p-0 m-0`,
          src: _unref(getPhotoUrl)(_unref(user)?.organisation.vorschaubild, { small: true }),
          "set-to-max": ""
        }, null, 8, ["src"])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(IonCardTitle), { class: "text-lg leading-5 md:text-xl mb-3 ion-inherit-color md" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(props.project.name), 1)
          ]),
          _: 1
        }),
        _createVNode(_unref(IonCardSubtitle), { class: "text-md ion-inherit-color md" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(user).organisation.name), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})